import { render, staticRenderFns } from "./EditVendor.vue?vue&type=template&id=3b32b6ea&scoped=true&"
import script from "./EditVendor.vue?vue&type=script&lang=js&"
export * from "./EditVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b32b6ea",
  null
  
)

export default component.exports